import { OrganizationRoleType } from "../../../../autogen/bff-api";

export const organizationContractRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ContractViewer,
];

export const organizationSourcingRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.SourcingViewer,
];

export const organizationEditSourcingRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
];

export const organizationProjectRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ProjectCreator,
  OrganizationRoleType.ProjectViewer,
];

export const organizationEditProjectRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ProjectCreator,
];

export const hasContractViewerAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationContractRoles.includes(role));
